import mainApiClient from "../../helpers/services/main-api-client";

const URL_REGEX =
  /https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_+.~#?&/=]*)/gi;

export function extractUrlsFromText(text: string): string[] {
  return text.match(URL_REGEX) || [];
}

export async function shortenUrlsInText(
  companyId: string | number,
  text: string
): Promise<string> {
  const source = String(text || "");
  if (!source.trim() || extractUrlsFromText(source).length === 0) {
    return source;
  }

  const { data } = await mainApiClient().post(
    `/short-links?companyId=${companyId}`,
    { text: source }
  );
  const next = data?.payload?.text;
  return typeof next === "string" ? next : source;
}
